import { Descriptions, Row, Tag, Card as AntdCard } from "antd";
import { Button } from "antd";
import React, { Fragment } from "react";
import {
  ContributionTypesEnum,
  Opportunity,
} from "../../../helpers/shared-interfaces";
import {
  contributionTypes,
  getStateColor,
  productPaymentTypes,
} from "../../../helpers/utilities";
import { contributionTypes as contributionTypeOptions } from "../../../helpers/constants";
import { getProgressStatus } from "../../Opportunities";
import EntitledSection from "../../../components/EntitledSection";
import entitlements from "../../../config/entitlements";

interface Props {
  opportunity: Opportunity;
  editButton: JSX.Element;
  toggleDelete: () => void;
}
  
export default function ({
  opportunity,
  editButton,
  toggleDelete,
}: Props): JSX.Element {
  return (
    <Fragment>
      <Row className="view-opportunity-row">
        <AntdCard
          title={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>Opportunity</span>

              <Tag
                color={getStateColor(
                  getProgressStatus(opportunity.progressStatus),
                )}
              >
                {getProgressStatus(opportunity.progressStatus)}
              </Tag>
              <span style={{ marginLeft: "auto" }}>
                <EntitledSection
                  entitlement={entitlements.Products.edit}
                >
                  {editButton}
                </EntitledSection>
              </span>
            </div>
          }
        >
          <Descriptions>
            {opportunity.opportunitySource && (
              <Descriptions.Item label={<b>Source</b>} key="Source">
                {opportunity.opportunitySource.name}
              </Descriptions.Item>
            )}
            <Descriptions.Item
              label={<b>Opportunity ID</b>}
              key="Opportunity ID"
            >
              {opportunity.id}
            </Descriptions.Item>

            {opportunity.opportunityProspect && (
              <Descriptions.Item label={<b>Prospect</b>} key="Prospect">
                {opportunity.opportunityProspect.name}
              </Descriptions.Item>
            )}

            {opportunity.product && (
              <Descriptions.Item label={<b>Product Name</b>} key="Product">
                {opportunity.product.name}
              </Descriptions.Item>
            )}

            {opportunity.createdBy && (
              <Descriptions.Item label={<b>Created By</b>} key="Created">
                {opportunity.createdBy.name}
              </Descriptions.Item>
            )}

            {opportunity.contributionType && (
              <Descriptions.Item
                label={<b>Contribution Type</b>}
                key={opportunity.contributionType}
              >
                {contributionTypes[opportunity.contributionType]}
              </Descriptions.Item>
            )}

            {(opportunity.contributionType ===
              ContributionTypesEnum.monthlyContribution ||
              opportunity.contributionType ===
                ContributionTypesEnum.monthlyAndLump) &&
              opportunity.monthlyExpectedContribution && (
                <Descriptions.Item
                  label={<b>Expected Monthly Contribution</b>}
                  key={opportunity.monthlyExpectedContribution}
                >
                  {opportunity.monthlyExpectedContribution} GHS
                </Descriptions.Item>
              )}

            {(opportunity.contributionType === ContributionTypesEnum.lumpSum ||
              opportunity.contributionType ===
                ContributionTypesEnum.monthlyAndLump) &&
              opportunity.lumpsumExpectedContribution && (
                <Descriptions.Item
                  label={<b>Expected Lump Sum Contribution</b>}
                  key={opportunity.lumpsumExpectedContribution}
                >
                  {opportunity.lumpsumExpectedContribution} GHS
                </Descriptions.Item>
              )}

            {opportunity.company?.numberOfEmployees && (
              <Descriptions.Item
                label={<b>Number of Employees</b>}
                key={opportunity.company?.numberOfEmployees}
              >
                {opportunity.company.numberOfEmployees}
              </Descriptions.Item>
            )}

            {opportunity.opportunityType && (
              <Descriptions.Item
                label={<b>Opportunity Type</b>}
                key="Opportunity Type"
              >
                {opportunity.opportunityType}
              </Descriptions.Item>
            )}

            {opportunity.opportunitySource &&
              opportunity.opportunitySource.name === "Referral" && (
                <Descriptions.Item label={<b>Referrer</b>} key="referrer">
                  {opportunity.referrer && opportunity.referrer.name}
                </Descriptions.Item>
              )}

            {opportunity.company?.trustee && (
              <Descriptions.Item label={<b>Former Trustee</b>} key="trustee">
                {opportunity.company.trustee.name}
              </Descriptions.Item>
            )}

            {opportunity.productPaymentType && (
              <Descriptions.Item
                label={<b>Product Payment Type</b>}
                key="Product Payment Type"
              >
                {productPaymentTypes[opportunity.productPaymentType]}
              </Descriptions.Item>
            )}

            {opportunity.sourceOfAwareness && (
              <Descriptions.Item
                label={<b>Source Of Awareness</b>}
                key="Source Of Awareness"
              >
                {opportunity.sourceOfAwareness}
              </Descriptions.Item>
            )}

            {opportunity.signupReason && (
              <Descriptions.Item
                label={<b>Signup Reason</b>}
                key="Signup Reason<"
              >
                {opportunity.signupReason}
              </Descriptions.Item>
            )}

            {opportunity.salesPerson && (
              <Descriptions.Item label={<b>Sales Person</b>} key="Sales Person">
                {opportunity.salesPerson?.name}
              </Descriptions.Item>
            )}

            {opportunity.assignee && (
              <Descriptions.Item label={<b>Assigned To</b>} key="Assigned To">
                {opportunity.assignee.name}
              </Descriptions.Item>
            )}

            {opportunity.contributionAllocationTypes &&
              opportunity.contributionAllocationTypes.length > 0 && (
                <Descriptions.Item
                  label={<b>Contribution Allocation Types</b>}
                  key="Contribution Allocation Types"
                >
                  {opportunity.contributionAllocationTypes
                    .map(
                      (type) =>
                        contributionTypeOptions.find(
                          (contributionType) => contributionType.id === type,
                        )?.name ?? type,
                    )
                    .join(", ")}
                </Descriptions.Item>
              )}
          </Descriptions>
        </AntdCard>
      </Row>
    </Fragment>
  );
}
